export default __webpack_public_path__ + "static/villa4-e1fc112f044e7b03e88b7c8f94e417e1.jpeg";